import { render, staticRenderFns } from "./SubscriptionsSelector.vue?vue&type=template&id=aa4d2b6e&"
import script from "./SubscriptionsSelector.vue?vue&type=script&lang=js&"
export * from "./SubscriptionsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports